import type { SbSDKOptions, StoryblokClient } from '@storyblok/js';
import { storyblokInit as sbInit } from '@storyblok/js';
import type { Component } from 'svelte';

let storyblokApiInstance: StoryblokClient;

export function storyblokInit(options: SbSDKOptions) {
	const { storyblokApi } = sbInit(options);
	if (storyblokApi) {
		storyblokApiInstance = storyblokApi;
	}
}

export function getApiClient(): StoryblokClient {
	if (!storyblokApiInstance) throw new Error('Call "storyBlokInit" and include the "apiPlugin".');

	return storyblokApiInstance;
}

export type AsyncComponent<
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	P extends Record<string, any>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	E extends Record<string, any>,
	B extends keyof P | ''
> = Promise<{ default: Component<P, E, B> }>;
export type StoryblokComponent<
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	P extends Record<string, any>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	E extends Record<string, any>,
	B extends keyof P | ''
> = Component<P, E, B> | AsyncComponent<P, E, B>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const componentMap = new Map<string, StoryblokComponent<any, any, any>>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerComponents(components: Record<string, StoryblokComponent<any, any, any>>) {
	for (const [key, component] of Object.entries(components)) {
		componentMap.set(key, component);
	}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getComponent(name: string): StoryblokComponent<any, any, any> | undefined {
	return componentMap.get(name);
}
